import { render, staticRenderFns } from "./ZonasImpresionCRUD.vue?vue&type=template&id=8fff9ad8"
import script from "./ZonasImpresionCRUD.vue?vue&type=script&lang=js"
export * from "./ZonasImpresionCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports